<template>
  <div class="slinky-loader"></div>
</template>

<script>
export default {
  name: "Slinky"
};
</script>

<style scoped>
@keyframes spin {
  to {
    transform: rotate(359deg);
  }
}
.slinky-loader {
  position: relative;
  margin-top: 20px;
  width: 40px;
  aspect-ratio: 1;
  border: 5px solid #555fff;
  animation: spin infinite 0.8s linear forwards;
  border-radius: 50%;
}

.slinky-loader::after {
  position: absolute;
  content: "";
  width: 30%;
  aspect-ratio: 1;
  top: 50%;
  left: 100%;
  transform: translate(-25%, -50%);
  background: white;
}
</style>



// WEBPACK FOOTER //
// Slinky.vue?0d2e8582